<zbp-zbchart-report-table
  reportLabel="Class Over Time Report Table"
  [showProgressReportsHelp]="true"
  [leftHeaderText]="'Test'"
  [rightHeaderText]="'Class Benchmarks and Status'"
  [zbChart]="zbChart"
  [printableReportHeadings]="printableReportHeadings"
  [isPrinting]="isPrinting"
/>
